import React from 'react'
import Fragment from '../common/fragment'


function FragmentCA(props) {
  return (
    <Fragment pos="aaa" {...props}>
      <p>
Cristo camino a Salamanca oscureció su cuerpo para que no lo encontraran sus
perseguidores. Se difuminó en la noche, oculto para esos ojos. ¿Dios se puede
ocultar o siempre se ve a sí mismo? Cristo Negro.
      </p>
    </Fragment>
  )
}


export default FragmentCA
